import { h } from 'preact'
import PropTypes from 'prop-types'
import classNames from 'lib/classNames'
import { useMyOrganizationMembership, useMyPublicProfile, usePublicProfile } from 'lib/membershipAppStateHooks'
import IconButton from 'components/IconButton'
import { useChatChannelsForPublicProfile, useCreateChatChannel } from 'lib/chatHooks'

export default function ChatButton({
  className,
  organizationApikey,
  publicProfileDid,
  ...props
}){
  const {
    myPublicProfile,
    myPublicProfileDid,
  } = useMyPublicProfile('ChatButton')
  const { myOrganizationMembership } = useMyOrganizationMembership(organizationApikey, 'ChatButton')
  const { chatChannels } = useChatChannelsForPublicProfile({
    publicProfileDid,
    organizationApikey,
  }, 'ChatButton')
  const { publicProfile } = usePublicProfile(publicProfileDid, 'ChatButton')
  const createChatChannel = useCreateChatChannel('ChatButton')

  const handleCreateChatChannel = async () => {
    if (chatChannels.length === 0) {
      await createChatChannel({
        type: 'dm',
        memberUserDids: [myPublicProfileDid, publicProfileDid],
        organizationApikey,
        name: `${publicProfile.username} - ${myPublicProfile.username} `,
        chatImage: publicProfile?.avatar || undefined,
      })
    }
  }

  if (
    !myOrganizationMembership ||
    !myOrganizationMembership.acceptedAt ||
    publicProfileDid === myPublicProfileDid
  ) return

  return (
    <IconButton
      {...props}
      className={classNames('ChatButton', { className })}
      type="messages"
      href={`/${organizationApikey}/chat/${publicProfileDid}`}
      onClick={handleCreateChatChannel}
    />
  )
}

ChatButton.propTypes = {
  className: PropTypes.string,
  organizationApikey: PropTypes.string.isRequired,
  publicProfileDid: PropTypes.string.isRequired,
}
